import React from 'react';
import PanettoneQuotaBossSale from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaBossSale/List.js';

export default function () {
  return <PanettoneQuotaBossSale />;
}
